<!--begin::Signin-->
<div class="login-form login-signin ">


    <div class="pb-11 pt-lg-0 pt-5" *ngIf="!isFinish">
        <h3 class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg">
            Summary</h3>
    </div>


    <div class="page-content page-container" id="page-content">
        <div class="">
            <div class="row  d-flex justify-content-center ">
                <div class="col-xl-12 col-md-12 ">
                    <div class="card user-card-full  background-color border-radius"  >
                        <div class="row m-l-0 m-r-0">

                            <div class="col-sm-12 padding-14"  style="padding-left: 30px">
                                <div class="card-block">

                                    <div class="row">
                                        <div class="col-12 col-lg-6 align-self-center-sm">
                                            <p class="m-b-10 f-w-600">Name</p>
                                            <h6 class="text-muted f-w-400 color-black">{{details?.first_name | titlecase}} {{details?.last_name | titlecase}}</h6>
                                        </div>
                                        <div class="col-12 col-lg-6 align-self-center-sm">
                                            <p class="m-b-10 f-w-600">Date of Birth</p>
                                            <h6 class="text-muted f-w-400 color-black">{{details?.dob  | date: 'dd/MM/yyyy' }}</h6>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-12 col-lg-6 align-self-center-sm">
                                            <p class="m-b-10 f-w-600">Address</p>
                                            <h6 class="text-muted f-w-400 color-black">{{details?.address}}</h6>
                                        </div>
                                        <div class="col-12 col-lg-6 align-self-center-sm">
                                            <p class="m-b-10 f-w-600">Marital Status</p>
                                            <h6 class="text-muted f-w-400 color-black">{{details?.marital?.status | titlecase}}</h6>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-12 col-lg-6 align-self-center-sm">
                                            <p class="m-b-10 f-w-600" *ngIf="details?.marital?.meta[0]?.name">Partner</p>
                                            <h6 class="text-muted f-w-400 color-black">{{details?.marital?.meta[0]?.name | titlecase}}</h6>
                                        </div>
                                        <div class="col-12 col-lg-6 align-self-center-sm">
                                            <p class="m-b-10 f-w-600" *ngIf="details?.children?.length ==1">Child</p>
                                            <p class="m-b-10 f-w-600" *ngIf="details?.children?.length > 1">Children</p>
                                            <div class="flex-row d-flex">
                                                <h6 class="text-muted f-w-400 color-black" *ngIf="details?.children?.length ==1">{{details?.children?.length || 0}} Child</h6>
                                                <h6 class="text-muted f-w-400 color-black" *ngIf="details?.children?.length >1">{{details?.children?.length || 0}} Children</h6>
                                                <button *ngIf="details?.children?.length >0" class="btn btn-primary  button-w40" (click)="viewChildrenEvent()"> View</button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-12 col-lg-6 align-self-center-sm">
                                            <p class="m-b-10 f-w-600" *ngIf="details?.pets?.length ==1">Pet</p>
                                            <p class="m-b-10 f-w-600" *ngIf="details?.pets?.length > 1">Pets</p>
                                            <div class="flex-row d-flex">
                                                <h6 class="text-muted f-w-400 color-black" *ngIf="details?.pets?.length ==1">{{details?.pets?.length || 0}} Pet</h6>
                                                <h6 class="text-muted f-w-400 color-black" *ngIf="details?.pets?.length >1">{{details?.pets?.length || 0}} Pets</h6>
                                                <button  *ngIf="details?.pets?.length > 0" class="btn btn-primary  button-w40" (click)="viewPetsEvent()"> View</button>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-12 col-md-12 " *ngIf="!isFinish">

                    <div class="row" style="margin: 0">
                        <div class="pb-lg-0 pb-5 mt-4 ">
                            <button type="button" class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-9 width-150" (click)="editProfile()">
                                Edit
                            </button>
                        </div>


                        <!--begin::Action-->
                        <!-- <div class="pb-lg-0 pb-5 mt-4 margin-l-20">
                            <button id="kt_login_signin_submit" class="btn-save font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-3 margin-left-auto width-150"  (click)="navigateToNextPage()">
                                Next
                            </button>
                        </div> -->


                    </div>

                </div>

            </div>


        </div>
    </div>
</div>



